import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState, MouseEvent } from "react";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";
import { SET_ATTENDANCE_END_POINT } from "../../../../config/config";
import { Notification } from "../../pop-ups/notification";
import { AxiosError } from "axios";
import { useAuth } from "../../../../services/auth-services/authContext";
import { AuthContextState } from "../../../../utils/types";
import { io } from "socket.io-client";
import { API_BASE_URL } from "../../../../config/config";

interface setTimeButtonProps {
    onSubmit : (success : any) => void;
    hasAttendanceToday : boolean;
}

const SetTimeButton : React.FC<setTimeButtonProps> = ({onSubmit, hasAttendanceToday}) =>{

    const [timeId, setTimeId] = useState<number>(1);
    const [breakTimeOption, setBreakTimeOption] = useState<boolean>(false);
    const [timeConsumed, setTimeConsumed] = useState<number>(90);
    const [showNotif, setShowNotif] = useState<boolean>(false);
    const [notifValue, setNotifValue] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [work_setup, set_work_setup] = useState<string>('wfh');

    const { decodedJwtData } = useAuth() as AuthContextState;

    useEffect(()=>{
        if(isSuccess){
            const socket = io(API_BASE_URL);
                
            socket.emit('update_attendance_log');
        
            return () => {
                if (socket) {
                socket.disconnect();
                }
            };
        }
    },[isSuccess]);
    
    useEffect(()=>{
        if(timeId === 2){
            setBreakTimeOption(true);
        }else{
            setBreakTimeOption(false);
        }
    },[timeId]);

    const handleSetAttendance = async(e : MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const data = {
            work_setup : work_setup,
            time_id : timeId,
            time_consumed : timeConsumed
        }
        const account_id = decodedJwtData?.userId; 

        setShowNotif(true);
        setNotifValue('Processing....');

        setTimeout(async()=>{
            try{
                const submitRes = await api.post(SET_ATTENDANCE_END_POINT+account_id, data, {
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setIsSuccess(true);
                setNotifValue('Attendance recorded.');
                onSubmit(submitRes);
            }catch(e){
                const error = (e as AxiosError);
                setIsSuccess(false);
                switch(error.response?.status){
                    case 400:
                        setNotifValue('Request unavailable');
                        break;
                    case 401:
                        setNotifValue('Session expired.');
                        break;
                    default:
                        setNotifValue('An error occured.');
                        break;
                }
            }
            setTimeout(()=>{
                setIsSuccess(null)
                setShowNotif(false)
            },1000)    
        },500)
    }

    return (
        <div className="ms-auto flex items-center gap-4">
            {!hasAttendanceToday && (
            <div>
                <select onChange={(e)=>set_work_setup(e.currentTarget.value)} className="text-box">
                    <option value="wfh">WFH</option>
                    <option value="onsite">ONSITE</option>
                </select>
            </div>
            )}
            <div>
                <select onChange={(e)=>setTimeId(parseInt(e.target.value))} className="text-box">
                    <option value={1}>Sign in</option>
                    <option value={2}>On Break</option>
                    <option value={3}>Off Break</option>
                    <option value={4}>Sign out</option>
                </select>
            </div>
            <div>
                <select onChange={(e)=>setTimeConsumed(parseInt(e.target.value))} className={breakTimeOption ? "text-box" : "hidden"}>
                    <option value={90}>90 Mins.</option>
                    <option value={60}>60 Mins.</option>
                    <option value={30}>30 Mins.</option>
                </select>
            </div>
            <div>
                <button type="button" onClick={handleSetAttendance} className="button button-vcc-primary text-sm">
                    <FontAwesomeIcon icon={faClock} />&nbsp;
                    Set Attendance
                </button>
            </div>
            {showNotif && (
                <Notification notif={notifValue} success={isSuccess} />
             )}
        </div>
    );
}

export default SetTimeButton;